import { combineReducers } from 'redux'
import soundReducer from 'app/store/reducers/sounds'
import ebooksReducer from 'app/store/reducers/ebooks/'
import theaterReducer from 'app/store/reducers/theater'
import userDataReducer from 'app/store/reducers/user-data.reducer'
import teacherGuideReducer from 'app/store/reducers/teacher-guide/'
import loadingStatus from './loading.reducer'
import { avatarBuilderReducer } from '../avatar-builder'

const rootReducer = combineReducers({
  sounds: soundReducer,
  ebooks: ebooksReducer,
  theater: theaterReducer,
  userData: userDataReducer,
  teacherGuide: teacherGuideReducer,
  loadingStatus,
  avatarBuilder: avatarBuilderReducer,
})

export default rootReducer
